export default __webpack_public_path__ + "static/media/device_health_monitoring_impression.090e76c2.png";